module.exports = __webpack_public_path__ + "img/bg-type04-mask.be409194.png";